import { ReactComponent, VueComponent} from "@js/utils/components";

// Register Vue components here
export const vue = [
    // new VueComponent("Exemple", "#exemple", Exemple)
]
VueComponent.initialize()

// Register React components here
export const react = [
    // new ReactComponent("Exemple", "#exemple", Exemple)
]
ReactComponent.initialize()
